import type { ShipmentStatus } from "./types";

function getStateAuthorName(author: UserRoleInfo) {
  return `${author.user.first_name} ${author.user.last_name}`;
}

export function buildSupplierShipmentStatusListFromShipmentLifecycle(
  shipment: SupplierShipment,
  route: Route | null,
) {
  const statuses: ShipmentStatus[] = [];

  if (shipment.booking_cancellation) {
    statuses.push({
      notes: shipment.booking_cancellation.reason || "",
      createdAt: shipment.booking_cancellation.created_at,
      timestamp: null,
      routePointNumber: null,
      createdBy: getStateAuthorName(shipment.booking_cancellation.created_by),
      type: "Booking Cancelled",
    });
  }

  if (shipment.first_pickup) {
    statuses.push({
      notes: shipment.first_pickup.notes ?? "",
      createdAt: shipment.first_pickup.created_at,
      timestamp: shipment.first_pickup.picked_up_at,
      routePointNumber: 1,
      createdBy: getStateAuthorName(shipment.first_pickup.created_by),
      type: "Shipment Picked Up",
    });
  }

  if (shipment.delivery) {
    statuses.push({
      notes: shipment.delivery.notes ?? "",
      createdAt: shipment.delivery.created_at,
      timestamp: shipment.delivery.delivered_at,
      routePointNumber: route != null ? route.route_points.length : null,
      createdBy: getStateAuthorName(shipment.delivery.created_by),
      type: "Shipment Delivered",
    });
  }
  return statuses;
}

export function buildShipmentStatusListFromRoutePointsETAs(
  etas: RoutePointETA[],
) {
  const statuses: ShipmentStatus[] = [];

  etas.forEach((eta) => {
    statuses.push({
      notes: eta.notes ?? "",
      createdAt: eta.created_at,
      timestamp: eta.eta,
      routePointNumber: eta.point.point_number,
      createdBy: getStateAuthorName(eta.created_by),
      type: "ETA Added",
    });
  });

  return statuses;
}
